import React, { useState } from "react";
import styles from "./Order.module.scss";
import { Container } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import OrderTransactionsComp from "../../../../components/AdminPortalComponents/BusinessManagement/OrderTransactions/OrderTransactions.comp";
import ComponentBackButton from "../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import InsightsIcon from "../../../../assets/icons/Admin/insights.svg"
import { useNavigate } from "react-router-dom";

const orderFulfillmentData = [
    { title: "Order Transactions", value: 0 },
    { title: "Total Revenue", value: 0 },
    { title: "Refunded Amount", value: 0 },
    { title: "Pending Transactions", value: 0 }
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));



const OrderTransactions = () => {
    const [detailView, setDetailView] = useState(false)

    const navigate = useNavigate()
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <div className={styles.topView} onClick={()=>navigate("transactionInsights")}>
                    <h5 className={styles.mainHeading}>Order Transactions Overview</h5>
                    <div className={styles.insightContainer}>
                        <h6 className={styles.transText}>Transactions Insights</h6>
                        <img src={InsightsIcon} className={styles.img} />
                        {/* <InsightsIcon/> */}
                    </div>
                </div>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orderFulfillmentData} />
                </div>
            </Container>
            {!detailView &&
                <>
                    <Container fluid className={styles.filterTableWrapper}>
                        <div className="p-3 d-flex align-items-center justify-content-between">
                            <div className={`fw-semibold fs-4 ${styles.text} `}>Order Transactions</div>
                        </div>

                        <OrderTransactionsComp setDetails={() => setDetailView(true)} />
                    </Container>
                </>}
            {detailView &&
                <Container fluid className={styles.orderWrapper}>
                    <ComponentBackButton onClick={() => setDetailView(false)} />
                    <div className={`fw-semibold text-center m-20 fs-4 ${styles.text} `}>Order Transaction Detail View  </div>
                </Container>
            }
        </div>
    );
};

export default OrderTransactions;